import { render, staticRenderFns } from "./godaddy.vue?vue&type=template&id=aef32234&scoped=true"
import script from "./godaddy.vue?vue&type=script&lang=js"
export * from "./godaddy.vue?vue&type=script&lang=js"
import style0 from "./godaddy.vue?vue&type=style&index=0&id=aef32234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef32234",
  null
  
)

export default component.exports